import requestNotif from '@/_helpers/requests/requestNotif'
import requestBlob from '@/_helpers/requests/requestBlob'

export const documentService = {
    getAll() {
    
        return new Promise((resolve) => {
    
            requestNotif.get('anexos').then(response => {
                resolve(response.data)
            });
        });
    },
    download(idAnexo, code) {

        return new Promise((resolve) => {
    
            requestBlob.get('anexos/getAnexo', { params: { anexo: idAnexo, code_auth: code == undefined ? '' : code }}).then(response => {
                resolve({file: response.data, name: response.headers['x-file-name']})
            },() => {
                resolve(false);
            });
        });
    },
    downloadDashboard(idAnexo) {

        return new Promise((resolve) => {
    
            requestBlob.get('anexos/getAnexoTablon', { params: { anexo: idAnexo}}).then(response => {
                resolve({file: response.data, name: response.headers['x-file-name']})
            },() => {
                resolve(false);
            });
        });
    }
};